import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseFilterService } from '../../../shared/services/base-filter.service';

export interface VendorUploadFilters {
  division: string;
  entity: string;
  vendorGroup: string;
}

const EMPTY_FILTERS: VendorUploadFilters = {
  division: '',
  entity: '',
  vendorGroup: '',
};

@Injectable({ providedIn: 'root' })
export class VendorUploadFilterService extends BaseFilterService<VendorUploadFilters> {
  protected readonly storageKey = 'vendor_upload_filters';
  protected readonly emptyFilters = EMPTY_FILTERS;

  applied$ = new Subject<void>();

  /** True while the page data is loading */
  gridLoading = signal(false);

  constructor() {
    super();
    this.init();
  }

  /** Full reset — call on logout so the singleton is clean for the next session */
  reset(): void {
    this.resetFilters();
    this.gridLoading.set(false);
  }

  get hasFilters(): boolean {
    const f = this.filters();
    return !!(f.division || f.entity || f.vendorGroup);
  }

  buildPayload(filters?: VendorUploadFilters): Record<string, any> {
    const f = filters ?? this.filters();
    return {
      division: f.division || null,
      entity: f.entity || null,
      vendorGroup: f.vendorGroup || null,
    };
  }

  protected parseStored(parsed: any): VendorUploadFilters {
    return {
      division: typeof parsed.division === 'string' ? parsed.division : '',
      entity: typeof parsed.entity === 'string' ? parsed.entity : '',
      vendorGroup: typeof parsed.vendorGroup === 'string' ? parsed.vendorGroup : '',
    };
  }
}
